import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _hoisted_1 = {
  key: 0,
  class: "opModal formContainer"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = {
  key: 0,
  class: "title"
}
const _hoisted_4 = {
  key: 1,
  class: "title"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "body" }
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-sm-12" }
const _hoisted_11 = { class: "col-sm-3" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "col-sm-3" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "col-sm-3" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "col-sm-3" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { class: "col-sm-3" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "col-sm-3" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "col-sm-3" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { class: "col-sm-3" }
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-sm-3" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = {
  key: 0,
  class: "col-6"
}
const _hoisted_31 = { class: "form-group prevSymbolInput" }
const _hoisted_32 = { class: "input_title" }
const _hoisted_33 = { class: "position-relative" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "symbolContainer" }, "@", -1)
const _hoisted_35 = {
  key: 1,
  class: "col-3 d-flex align-items-center"
}
const _hoisted_36 = {
  key: 2,
  class: "col-12"
}
const _hoisted_37 = { class: "table table-striped" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { colspan: "99" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "text-center mt-5" }
const _hoisted_43 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!
  const _directive_localizedPlaceholder = _resolveDirective("localizedPlaceholder")!

  return (_ctx.vm)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.vm.identifier)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Edit Company",
                  text: "Edit Company"
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Create Company",
                  text: "Create Company"
                })
              ])),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-modal-close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_form_field, {
                  type: "text",
                  labelKey: "Company Name",
                  labelValue: "Company Name",
                  placeholderKey: "Company Name",
                  placeholderValue: "Company Name",
                  modelValue: _ctx.vm.companyName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vm.companyName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "1-2 & reporting license",
                      text: "1-2 & reporting license"
                    })
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["sameAsCheckbox me-2", {'active': _ctx.vm.hasScope12License}]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.vm.hasScope12License = !_ctx.vm.hasScope12License))
                  }, null, 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("label", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Product license",
                      text: "Product license"
                    })
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["sameAsCheckbox me-2", {'active': _ctx.vm.hasProductLicense}]),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.vm.hasProductLicense = !_ctx.vm.hasProductLicense))
                  }, null, 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("label", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Provider license",
                      text: "Provider license"
                    })
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["sameAsCheckbox me-2", {'active': _ctx.vm.hasProviderLicense}]),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.vm.hasProviderLicense = !_ctx.vm.hasProviderLicense))
                  }, null, 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Scoring license",
                      text: "Scoring license"
                    })
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["sameAsCheckbox me-2", {'active': _ctx.vm.hasScoringLicense}]),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.vm.hasScoringLicense = !_ctx.vm.hasScoringLicense))
                  }, null, 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("label", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Industrial mode",
                      text: "Industrial mode"
                    })
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["sameAsCheckbox me-2", {'active': _ctx.vm.hasIndustrialMode}]),
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.vm.hasIndustrialMode = !_ctx.vm.hasIndustrialMode))
                  }, null, 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Fabric compositions",
                      text: "Fabric compositions"
                    })
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["sameAsCheckbox me-2", {'active': _ctx.vm.hasFabricList}]),
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.vm.hasFabricList = !_ctx.vm.hasFabricList))
                  }, null, 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Optimizer",
                      text: "Optimizer"
                    })
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["sameAsCheckbox me-2", {'active': _ctx.vm.hasOptimizer}]),
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.vm.hasOptimizer = !_ctx.vm.hasOptimizer))
                  }, null, 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Due Diligence",
                      text: "Due Diligence"
                    })
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["sameAsCheckbox me-2", {'active': _ctx.vm.hasDueDiligenceLicense}]),
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.vm.hasDueDiligenceLicense = !_ctx.vm.hasDueDiligenceLicense))
                  }, null, 2)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("label", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Login from domain",
                      text: "Login from domain"
                    })
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["sameAsCheckbox me-2", {'active': _ctx.vm.loginFromDomain}]),
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.vm.loginFromDomain = !_ctx.vm.loginFromDomain))
                  }, null, 2)
                ])
              ]),
              (_ctx.vm.loginFromDomain)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("label", _hoisted_32, [
                        _createVNode(_component_localized_text, {
                          class: "fev_text5 fw_600",
                          localizedKey: "Domain",
                          text: "Domain"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.tempDomain) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.tempDomain],
                          [_directive_localizedPlaceholder, { key: 'Domain', value: 'Domain', prevText: '', afterText: '' }]
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.vm.loginFromDomain)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.addDomain()))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Add Domain",
                        text: "Add Domain"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.vm.loginFromDomain)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createElementVNode("table", _hoisted_37, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Domain",
                              text: "Domain"
                            })
                          ]),
                          _hoisted_38
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_ctx.vm.domains.length == 0)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
                              _createElementVNode("td", _hoisted_40, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: "No Elements Found",
                                  text: "No Elements Found"
                                })
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.domains, (domain, indice) => {
                          return (_openBlock(), _createElementBlock("tr", { key: domain }, [
                            _createElementVNode("td", null, _toDisplayString(domain), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("button", {
                                class: "btn btn-primary",
                                onClick: ($event: any) => (_ctx.removeDomain(indice))
                              }, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: "Remove Domain",
                                  text: "Remove Domain"
                                })
                              ], 8, _hoisted_41)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              disabled: _ctx.canSave,
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Save",
                text: "Save"
              })
            ], 8, _hoisted_43)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}